import { render, staticRenderFns } from "./MiniProgramYanYunDongOrderProduct.vue?vue&type=template&id=bbdc052e&scoped=true&"
import script from "./MiniProgramYanYunDongOrderProduct.vue?vue&type=script&lang=js&"
export * from "./MiniProgramYanYunDongOrderProduct.vue?vue&type=script&lang=js&"
import style0 from "./MiniProgramYanYunDongOrderProduct.vue?vue&type=style&index=0&id=bbdc052e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdc052e",
  null
  
)

export default component.exports